import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-900 mb-12">Terms of Use</h1>
        
        <div className="bg-white rounded-xl shadow-lg p-8 space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-600">
            By accessing and using AI Hairstyle Studio, you agree to be bound by these Terms of Use.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">2. Services Description</h2>
          <p className="text-gray-600">
            AI Hairstyle Studio provides AI-powered hairstyle visualization services. Your data is safe and not uploaded on any third-party app.
          </p>
          <p className="text-gray-600">
            The service is priced at $2 per image generation. Please note, there is a no-refund policy.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">3. User Responsibilities</h2>
          <p className="text-gray-600">
            Users are responsible for ensuring the accuracy of the data they provide and for complying with all applicable laws while using the service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">4. Limitation of Liability</h2>
          <p className="text-gray-600">
            AI Hairstyle Studio is not liable for any damages arising from the use of its services, including but not limited to incorrect visualizations or user dissatisfaction.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">5. Changes to Terms</h2>
          <p className="text-gray-600">
            AI Hairstyle Studio reserves the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting.
          </p>
        </section>

        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;